export default `
fragment ParagraphDataCard on ParagraphDataCard {
  id
  uuid
  entityBundle
  title
  subtitle
  icon {
    entity {
      name
      media {
        entity {
          ...Media
        }
      }
    }
  }
}
`